import { toast as sonner } from 'sonner';

/* ══════════════════════════════════════════════════════
   TOAST STORE — Thin ergonomic wrapper around sonner
   - Provides a stable API the app uses (toast.success/error/info/warn)
   - Lets us swap implementations later without touching call sites
   - sonner's <Toaster /> must be mounted in App.jsx (see setup)
   - All toasts respect prefers-reduced-motion via sonner's defaults
   ══════════════════════════════════════════════════════ */

const DEFAULTS = { duration: 3000 };

export const toast = {
  success: (msg, opts = {}) => sonner.success(msg, { ...DEFAULTS, ...opts }),
  error: (msg, opts = {}) => sonner.error(msg, { ...DEFAULTS, duration: 5000, ...opts }),
  info: (msg, opts = {}) => sonner(msg, { ...DEFAULTS, ...opts }),
  warning: (msg, opts = {}) => sonner.warning(msg, { ...DEFAULTS, ...opts }),
  loading: (msg, opts = {}) => sonner.loading(msg, opts),
  dismiss: (id) => sonner.dismiss(id),
  promise: (promise, opts) => sonner.promise(promise, opts),
};

export default toast;
